var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShip(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 14,
    viewBox: "0 0 20 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 8.2L2.03269 12.428C2.11471 12.7638 2.41561 13 2.76127 13H15.1868C15.4734 13 15.7349 12.8367 15.8607 12.5792L18 8.2H16.2414M1 8.2H16.2414M1 8.2L2.17241 5.8M16.2414 8.2L15.2745 6.2208C15.1487 5.96331 14.8872 5.8 14.6006 5.8H13.3103M2.17241 5.8H13.3103M2.17241 5.8V4.15C2.17241 3.73579 2.5082 3.4 2.92241 3.4H3.34483M13.3103 5.8L12.3435 3.8208C12.2177 3.56331 11.9562 3.4 11.6696 3.4H8.32759M8.32759 3.4L7.8811 1.57204C7.79908 1.23625 7.49819 1 7.15252 1H6.938C6.45174 1 6.09404 1.45559 6.20942 1.92796L6.56897 3.4M8.32759 3.4H6.56897M6.56897 3.4H5.10345M5.10345 3.4L4.65696 1.57204C4.57495 1.23625 4.27405 1 3.92838 1H3.71386C3.22761 1 2.8699 1.45559 2.98528 1.92796L3.34483 3.4M5.10345 3.4H3.34483",
    stroke: "#0C214D",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShip);
export default __webpack_public_path__ + "static/media/ship.34a30bdf283cb5bcc18feb3cfbd49ba0.svg";
export { ForwardRef as ReactComponent };